<template>
    <div class="prog-set-form-right-wrap">

        <Scrollbar class="data-list-right" :show_bar="true" v-if="handle_data.length > 0">
            <div class="big-title" v-if="is_show_all">Application Settings</div>
            <div class="tab-head" v-else v-show="!sub_fill_page">
                <h2>Settings</h2>
                <Navi :menu="tab_menus" :type="1" @selected-tab="tab_index = ($event + 1)" ref="nav" />
            </div>

            <!-- General Settings[0] -->
            <div class="set-box" v-if="tab_index === 1 || is_show_all">
                <div class="title-top">
                    <div class="title">{{ handle_data[0].name }}</div>
                    <Badage class="img-bagage" :value="bagage.value" :type="bagage.color" :border="'4'" />
                </div>
                <div class="content-box">
                    <div class="text-box">
                        <div class="small-text">Application title (internal) & link <svg-icon name="pen"
                                @click="$refs.add.open(handle_data[0].section_groups[0].group_setting);" /></div>
                        <div class="small-text-dec">
                            {{ handle_data[0].section_groups[0].group_setting[0].input_value }}</div>
                        <tippy :content="url_link ">
                            <a :href="url_link" target="_blank" class="url url-link-one-line">
                            {{ url_link }}
                            </a>
                        </tippy>
                    </div>

                    <div class="text-box">
                        <div class="small-text">Application period (UTC)</div>
                        <div class="desc">Automatically open application when published.</div>
                    </div>

                    <div class="date-box"
                        v-for="(v, k) in handle_data[0].section_groups[1].group_setting.filter((e, kk) => { return kk <= 1 })"
                        :key="k">
                        <div class="title">
                            {{ v.client_view.name }}:
                            <Switch :checked="v.client_view.show"
                                @click.native="v.client_view.show = v.client_view.show ? false : true; $emit('update-data', { data:handle_data });" />
                        </div>
                        <div class="show" v-show="v.client_view.show">
                            <div class="desc">{{ v.client_view.desc }}</div>
                            <DateTimePicker :date="v.client_view.date" :time="v.client_view.time"
                                :datetime="v.client_view.val"
                                :format="v.client_view.plac" @update-date="calendarChange" @update-time="timeChange"
                                :spec_val="v.client_view.name"
                                :max_date="v.client_view.max_date ? v.client_view.max_date : null"
                                :min_date="v.client_view.min_date ? v.client_view.min_date : null" />
                        </div>
                    </div>

                    <div class="text-box" v-if="application_status !=='draft'">
                        <div class="small-text">{{ handle_data[0].section_groups[1].group_setting[2].client_view.name }}
                            <Switch :checked="handle_data[0].section_groups[1].group_setting[2].client_view.show"
                                @click.native="handle_data[0].section_groups[1].group_setting[2].client_view.show = handle_data[0].section_groups[1].group_setting[2].client_view.show ? false : true; $emit('update-data', { data:handle_data });" />
                        </div>
                        <div class="desc">{{ handle_data[0].section_groups[1].group_setting[2].client_view.desc }}
                        </div>
                    </div>
                </div>
            </div>

            <!-- Response Settings[1] -->
            <div class="set-box" v-if="tab_index === 2 || is_show_all">
                <div class="title-top">
                    <div class="title">{{ handle_data[1].name }}</div>
                </div>

                <div class="content-box">

                    <!--編輯訊息的-->
                    <div class="text-box" v-for="(v, k) in handle_data[1].section_groups.filter(e=>{return e.tip ==='sub-mes'} )" :key="k">
                        <div class="small-title-box">
                            <p>{{ v.name }}</p>
                            <div class="small-title-box-right">
                                <div class="open-pre" @click="openPreview(v)">Preview</div>
                                <svg-icon name="pen" @click="openTanking(v)" />
                            </div>
                        </div>
                        <div class="sub-mes-box" v-for="(vv, kk) in v.group_setting" :key="kk">
                            <div class="s-tit">{{ vv.client_view.name }}:</div>

                            <div class="desc"
                                v-if="!vv.client_view.is_edit">{{ vv.client_view.val ? vv.client_view.val : vv.client_view.plac }}</div>
                            
                            <Field v-else :type="vv.client_view.client_type"
                                :k="v.group_name"
                                :placeholder="vv.client_view.plac"
                                :had_value="vv.client_view.val"
                                @update="update" :ref="(el) => { els.push(el) }" :spec="kk"
                                :max_value="vv.client_view.max_value" />
                        </div>
                    </div>

                    <!-- 編輯信件的 -->
                    <div class="text-box">
                        <div class="small-text">
                            Automated email
                            <Switch :checked="auto_email" @click.native="handleAllEmailAuto" />
                        </div>
                        <div class="desc">This allows the applicant to receive an immediate email
                            follow-up regarding their application decision.</div>
                    </div>

                    <!-- application-handle -->
                    <div class="application-handle">
                        <div class="text-box" v-for="(v, k) in handle_data[1].section_groups.filter(e=>{return e.tip ==='application'} )"
                            :key="k">
                            <div class="small-text">
                                {{ v.name }}
                                <Switch :checked="v.is_switch"
                                    @click.native="switchOneResonse(v)" />
                            </div>

                            <div v-if="v.is_switch">
                                <div class="desc">{{ v.desc }}</div>
                                <div class="btn-sch-box" v-if="checkScIndex(v) !== -1">
                                    <div :class="['btn', v.group_setting[checkScIndex(v)].client_view.val === 'immediately' && 'pick-btn']" 
                                        @click="v.group_setting[checkScIndex(v)].client_view.val = 'immediately'; $emit('update-data', { data:handle_data });">
                                        Immediately <svg-icon v-if="v.group_setting[checkScIndex(v)].client_view.val === 'immediately'" name="yes-2" />
                                    </div>
                                    <div :class="['btn', v.group_setting[checkScIndex(v)].client_view.val === 'scheduled' && 'pick-btn']"
                                        @click="v.group_setting[checkScIndex(v)].client_view.val = 'scheduled'; $emit('update-data', { data:handle_data });">
                                        Scheduled <svg-icon v-if="v.group_setting[checkScIndex(v)].client_view.val === 'scheduled'" name="yes-2" />
                                    </div>
                                </div>

                                <div :class="['date-time-pick-box',v.group_setting[checkTimeIndex(v)].client_view.err && 'date-time-pick-box-err']"
                                    v-if="checkScIndex(v) !== -1 && v.group_setting[checkScIndex(v)].client_view.val === 'scheduled' && checkTimeIndex(v) !== -1">
                                    <div class="desc">Applicant will receive it at the following time(UTC):</div>
                                    <!-- {{ v.group_setting[checkTimeIndex(v)] }} -->
                                    <DateTimePicker 
                                        :key="v.group_setting[checkTimeIndex(v)].client_view.refrash_key" 
                                        :date="v.group_setting[checkTimeIndex(v)].client_view.date" 
                                        :time="v.group_setting[checkTimeIndex(v)].client_view.time" 
                                        :datetime="v.group_setting[checkTimeIndex(v)].client_view.val"
                                        :format="v.group_setting[checkTimeIndex(v)].client_view.plac" 
                                        @update-date="calendarChange" 
                                        @update-time="timeChange" 
                                        :spec_val="v.group_setting[checkTimeIndex(v)].client_view.name"
                                        :min_date="minDate(v.group_setting[checkTimeIndex(v)].label)"
                                        :index="v.index"
                                    />
                                </div>

                                <div :class="['edit-box',v.err && 'edit-box-red', !permission_recruitment?.editEmailTemplates?.permission && 'dis-edit-box']" @click="$refs.editResTemplate.open(v)">
                                    <svg-icon name="pen" /> Edit template
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>

            <!-- Auto-Rejection[3] -->
            <div class="set-box" v-if="(tab_index === 3 || is_show_all)">
                <div class="title-top">
                    <div class="title">{{ handle_data[3].name }}</div>
                    <Switch :checked=" autoRejAllHide || !otherGroupsOpen? false : handle_data[3].section_groups[0].is_switch"
                    @click.native="switchOneAuto(0,autoRejDis)" v-if="!autoRejAllHide"/>
                </div>
                <div class="desc">{{ handle_data[3].desc }}</div>

                <div class="content-box">
                    <!-- age -->
                    <div class="text-box" v-if="$ProjectName !== 'sephora'">
                        <div class="small-text">
                            {{ handle_data[3].section_groups[1].name}}
                            <Switch :checked="handle_data[3].section_groups[1].is_switch" @click.native="switchOneAuto(1,autoRejDis.age)" />
                        </div>
                        
                        <div v-if="handle_data[3].section_groups[1].is_switch">
                            <div class="desc">{{handle_data[3].section_groups[1].desc}}</div>
                            <div :class="['value-box', v.client_view.err && 'value-box-err']" v-for="(v,k) in handle_data[3].section_groups[1].group_setting" :key="k">
                                <div class="left-text">{{ v.client_view.name }} <span v-if="k===0" class="red"> *</span></div>
                                <!-- 錯誤訊息有兩種，單純的min沒填，錯誤訊息就不傳進field，但如果是大小相反，會傳進去 -->
                                <Field :type="'number'"
                                    :k="v.label"
                                    :placeholder="v.client_view.plac"
                                    :had_value="v.client_view.val"
                                    :error_msg="handle_data[3].section_groups[1].error_msg && !handle_data[3].section_groups[1].group_setting[0].client_view.err"
                                    :no_show_err_msg="true" :spec="'age-check'"
                                    @update="update" :ref="(el) => { els.push(el) }"/>
                            </div>
                            <div class="err-msg" v-if="handle_data[3].section_groups[1].error_msg">{{ handle_data[3].section_groups[1].error_msg }}</div>
                        </div>
                    </div>

                    <!-- location -->
                    <div class="text-box">
                        <div class="small-text">
                            {{handle_data[3].section_groups[2].name}}
                            <Switch :checked="handle_data[3].section_groups[2].is_switch" @click.native="switchOneAuto(2, autoRejDis.loc)" />
                        </div>

                        <div v-if="handle_data[3].section_groups[2].is_switch">
                            <div class="desc">{{handle_data[3].section_groups[2].desc}}</div>
                            <div class="select-box">
                                <Dropdown :items="handle_data[3].section_groups[2].group_setting[0].client_view.input_option" :icon_direction_type="'none'"
                                    @update-dropdown="updateLocation" :only_pick="true"/>
                                <ul>
                                    <div class="ul-box">
                                        <li v-for="(item, tagIndex) in handle_data[3].section_groups[2].group_setting[0].client_view.val" :key="tagIndex">
                                            <Button size="24" color="black-10" :border_r="'4'">{{ item.text }} 
                                                <i @click="remove(item)"><svg-icon name="remove" /></i></Button>
                                        </li>
                                    </div>
                                </ul>
                            </div>
                        </div>
                    </div>

                    <!-- follow -->
                    <div class="text-box">
                        <div class="small-text">
                            {{handle_data[3].section_groups[3].name}}
                            <Switch :checked="handle_data[3].section_groups[3].is_switch" @click.native="switchOneAuto( 3, autoRejDis.follow)" />
                        </div>

                        <div v-if="handle_data[3].section_groups[3].is_switch">
                            <div class="desc">{{handle_data[3].section_groups[3].desc}}</div>

                            <div class="value-box">
                                <div class="left-text"><svg-icon name="tiktok" /></div>
                                <div class="flex" @click="handleSocAlert('tk')">
                                    <Field v-for="(v,k) in handle_data[3].section_groups[3].group_setting.filter(e=>{return e.type==='tk'})"
                                        :type="'number'" :k="v.label" :placeholder="v.client_view.plac"
                                        :had_value="v.client_view.val"
                                        :is_disabled="!handle_data[3].section_groups[3].tk_show"
                                        :no_show_err_msg="true" :spec="'tk-follow'"
                                        @update="update" :ref="(el) => { els.push(el) }"/>
                                </div>
                            </div>
                            
                            <div class="value-box">
                                <div class="left-text"><svg-icon name="instagram" /></div>
                                <div class="flex" @click="handleSocAlert('ig')">
                                    <Field v-for="(v,k) in handle_data[3].section_groups[3].group_setting.filter(e=>{return e.type==='ig'})"
                                    :type="'number'" :k="v.label" :placeholder="v.client_view.plac"
                                    :had_value="v.client_view.val"
                                    :is_disabled="!handle_data[3].section_groups[3].ig_show"
                                    :no_show_err_msg="true" :spec="'ig-follow'"
                                    @update="update" :ref="(el) => { els.push(el) }"                          
                                    />
                                </div>
                            </div>
                            <!-- 100012 new -->
                            <Checkbox size="small" class="follow-check" :label_text="' Require applicants to meet both minimums for authenticated accounts.'" :checked="followIndex===0"
                            @click="checkFollowIndex()" :disabled="!checkFollow()"/>
                        </div>
                    </div>
                </div>
            </div>

            <div class="set-box" v-if="!is_show_all" v-show="tab_index === 4">
                <ProgAgreement :data="data.agreements_disclaimers" :brand_name="brand_name" ref="pa" />
            </div>

            <div class="set-box" v-if="!is_show_all" v-show="tab_index === 5">
                <ProgParentEdit :data="data.parent_guardian_consent" :hide_head="true" ref="pp" @hide="this.data.block_status.find((o) => o.name === 'parent_guardian_consent').open = !this.data.block_status.find((o) => o.name === 'parent_guardian_consent').open" :is_need="this.data.block_status.find((o) => o.name === 'parent_guardian_consent').open" />
            </div>
        </Scrollbar>
        
        <footer class="foot-box" v-if="!is_show_all">
            <Button type="button" :border_r="6" color="white" size="40" @click="$emit('close')">Cancel</Button>
            <Button type="button" :border_r="6" color="dark-blue" size="40" @click="save(1)" :is_disabled="!is_can_save || !is_inited">Save & apply</Button>
        </footer>
   
        <AddProgramPop ref="add" @save="saveTitle" :need_des="true" :is_edit="is_edit" :ambassador_application_id="ambassador_application_id"  :application_status="application_status"/>
        <EditResTemplate ref="editResTemplate" :handle_data="handle_data" @calendarChange="calendarChange" @timeChange="timeChange" @emailSave="emailSave" @updateData="updateDataInSide" :ambassador_application_id="ambassador_application_id" :ambassador_application_name="title"/>
        
        <FormForUserFillin @close="sub_fill_page=false;"/>
        <SubMesEditPop ref="submes" @openPre="openPreview" @save="saveTanking"/>
    </div>
    <Modal :is_show="is_show_save_modal" class="alert-modal" @click-bg="is_show_save_modal = false">
        <div class="box">
            <header class="delete-header">Update application?</header>
            <p>Changes to your settings will be reflected with future applicants and will not affect any prior applicants.</p>
            <div class="btns">
                <Button type="button" :border_r="6" color="white" size="32" @click="is_show_save_modal = false">Cancel</Button>
                <Button type="button" :border_r="6" color="dark-blue" size="32" @click="is_show_save_modal = false; save(2)">Save</Button>
            </div>
        </div>
    </Modal>

    <!-- <Modal :is_show="is_show_alert_modal" class="alert-modal" @click-bg="is_show_alert_modal = false">
        <div class="box">
            <header class="delete-header">{{alert.header}}</header>
            <div class="btns">
                <Button type="button" :border_r="6" color="dark-blue" size="32" @click="is_show_alert_modal = false">Ok</Button>
            </div>
        </div>
    </Modal> -->

    <Modal :is_show="is_show_alert2_modal" class="application-alert-modal2" @click-bg="is_show_alert2_modal = false">
        <div class="box">
            <header class="delete-header"><h2>Action required</h2><i @click="is_show_alert2_modal = false"><svg-icon name="close" /></i></header>
            <div class="content">
                <img :src="alert.img" alt="img">
              
                <h3>{{alert.header}}</h3>
                <div v-html="alert.text"></div>
                <Button type="button" :border_r="6" color="dark-blue" size="32" @click="is_show_alert2_modal = false">Ok</Button>
            </div>
            
           
        </div>
    </Modal>
</template>

<script>
import Button from '@/components/ui/Button.vue';
import Modal from '@/components/ui/Modal.vue';
import Field from '@/components/ui/Field.vue';
import Form from '@/components/ui/Form.vue';
import Checkbox from '@/components/ui/Checkbox.vue';
import Loading from '@/components/ui/Loading.vue';
import NoData from '@/components/creator/NoData.vue';
import Scrollbar from '@/components/ui/Scrollbar.vue';
import Dropdown from '@/components/ui/Dropdown.vue';
import Switch from '@/components/ui/Switch.vue';
import DateTimePicker from '@/components/ui/DateTimePicker.vue';
import moment from 'moment';
import Badage from '@/components/ui/Badage.vue';
import { checkScIndex,checkTimeIndex,combineDateTime } from '@/utils/ProgramsData.js';
import AddProgramPop from '@/components/programs/AddProgramPop.vue';
import EditResTemplate from '@/components/programs/Form/EditResTemplate.vue';
import ProgAgreement from './ProgAgreement.vue';
import Navi from '@/components/Navi.vue';
import ProgParentEdit from './ProgParentEdit.vue';
import FormForUserFillin from './FormForUserFillIn.vue';
import SubMesEditPop from './SubMesEditPop.vue';

export default {
    name: 'ProgramForm',
    emits: ['update-data'],
    data() {
        return {
            tab_index: 1,
            values: {},
            handle_data: [],
            els: [],
            auto_email: false,
            location_pick: [],
            backup_data: [],
            is_inited: false,
            is_show_save_modal: false,
            tab_menus: [
                {
                    text: 'General',
                },
                {
                    text: 'Response',
                },
                {
                    text: 'Auto-Rejection',
                },
            ],
            sub_fill_page:false,
            is_show_alert_modal:false,
            is_show_alert2_modal:false,
            alert:{
                header:'',
                img:'',
                text:'',
            },
            followIndex:1,//1or,0and
        }
    },

    props: {
        data: {
            type: Object,
            default: {}
        },

        is_edit: {
            type: Boolean,
            default: false
        },

        //this is project title
        title: {
            type: String,
            default: ''
        },
        type:{
            type: String,
            default: 'create'
        },

        is_show_all:{
            type:Boolean,
            default:false,
        },

        application_status:{
            type: String,
            default: ''
        },
        
        ambassador_application_id:{
            type: Number,
            required: true
        },

        ambassador_application_name:{
            type: String,
            default: '',
        },
    },

    computed: {
        permission_recruitment(){
            return this.$store.state.user_data?.permission_list?.recruitment;
        },

        url_link (){
            let url = this.$store.state.user_data ? this.$store.state.user_data.merchant_account.anchor_ambassador_subdomain: `${this.$store.state.user_data.merchant_account.merchant_display_name}.anchor.store`
            return `${url}/p/${this.handle_data[0].section_groups[0].group_setting[1].input_value}`
        },

        is_can_save() {
            // check data is change

            return !(
                JSON.stringify(this.handle_data) === JSON.stringify(this.backup_data.settings) &&
                JSON.stringify(this.data.agreements_disclaimers) === JSON.stringify(this.backup_data.agreements_disclaimers) &&
                JSON.stringify(this.data.block_status) === JSON.stringify(this.backup_data.block_status) &&
                JSON.stringify(this.data.parent_guardian_consent) === JSON.stringify(this.backup_data.parent_guardian_consent)
            );
        },
        
        brand_name() {
            return this.$store.state.user_data.merchant_account.merchant_display_name;
        },

        bagage(){
            if (this.application_status === 'draft' || !this.application_status) {
                return {
                    value:'Draft',
                    color:'dis'
                }
            } else if (this.application_status === 'closed'){
                return {
                    value:'Closed',
                    color:'dis'
                }
            } else if (this.application_status === 'scheduled'){
                return {
                    value:'Scheduled',
                    color:'sch'
                }
            } else {
                return {
                    value:'Active',
                    color:'act'
                }
            }
        },

        autoRejDis(){
            return {
                age:!this.handle_data[3].section_groups[1].showtoUser,
                loc:!this.handle_data[3].section_groups[2].showtoUser,
                follow:!this.handle_data[3].section_groups[3].showtoUser || ( !this.handle_data[3].section_groups[3].tk_show && !this.handle_data[3].section_groups[3].ig_show ),
                tk_f:!this.handle_data[3].section_groups[3].tk_show,
                ig_f:!this.handle_data[3].section_groups[3].ig_show,
            }
        },

        autoRejAllHide() {
            const sectionGroups = this.handle_data[3] && this.handle_data[3].section_groups ? this.handle_data[3].section_groups : [];

            // 跳第0个元素
            const otherGroupsCheck = sectionGroups.slice(1).every((group, index) => {
                if (index === 2) { // index = 3 in the original array since we're slicing from 1
                    // 如果唯一为 true 的是 index = 3，则检查 tk_show 和 ig_show
                    if (group.showtoUser === true) {
                        return !(group.tk_show === true || group.ig_show === true); // 如果 tk_show 和 ig_show 都为 false，则返回 true
                    }
                }
                // 如果 showtoUser 是 true，且不是 index = 3，直接返回 false
                return group.showtoUser === false;
            });

            return otherGroupsCheck ? true : false;
        },

        otherGroupsOpen() {
            const sectionGroups = this.handle_data[3] && this.handle_data[3].section_groups ? this.handle_data[3].section_groups : [];
            // 跳第0个元素
            const otherGroupsOpen = sectionGroups.slice(1).some((group, index) => {
                return group.is_switch;
            });

            return otherGroupsOpen;
        }
    },

    components: {
        Scrollbar,
        Field,
        Button,
        Form,
        Checkbox,
        Modal,
        NoData,
        Loading,
        Dropdown,
        Badage,
        DateTimePicker,
        Switch,
        AddProgramPop,
        EditResTemplate,
        ProgAgreement,
        Navi,
        ProgParentEdit,
        FormForUserFillin,
        SubMesEditPop,
    },

    watch: {
        title(val) {
            if (val) {
                this.handle_data[0].section_groups[0].group_setting[0].input_value = val;
            }
        },
        autoRejAllHide(val){
            this.hanldeAutoRe(val);
        },
    },

    methods: {

        minDate(label){
            const current_utc_date = moment.utc().subtract(1, 'days').format('YYYY-MM-DD HH:mm:ss');
            if (label === 'application_storefront_invite_receive_date') {
                const application_approved = this.handle_data[1].section_groups.find(e => e.group_name === 'application_approved');
                const application_approved_date = application_approved.group_setting.find(e => e.label === 'application_approved_receive_date');
                const application_approved_send_mode = application_approved.group_setting.find(e => e.label === 'application_approved_send_mode');

                console.log(application_approved);
                if (application_approved.is_switch && application_approved_send_mode.client_view.val === 'scheduled' && application_approved_date.client_view.val) {
                    return application_approved_date.client_view.val;
                } else {
                    return current_utc_date;
                }
                

            } else {
                return current_utc_date;

            }

        },

        openTanking(val){
            this.$refs.submes.open(val);
        },

        openPreview(v,vv,kk){
            this.sub_fill_page=true;
            console.log(v)
            this.EventBus.emit('open-form-fillin',{data:v,title: this.handle_data[0].section_groups[0].group_setting[0].input_value});
        },

        save(type) {
            if (type === 1) {
                this.is_show_save_modal = true;
                return;
            }

            let agreements_disclaimers = [];
            let parent_guardian_consent = [];

            if (this.data.agreements_disclaimers && this.data.agreements_disclaimers.length !== 0) agreements_disclaimers = this.$refs.pa.save(true);
            if (this.data.parent_guardian_consent && this.data.parent_guardian_consent.length !== 0) parent_guardian_consent = this.$refs.pp.save(true);

            setTimeout(() => {
                this.$emit('save', {
                    settings: this.data.settings,
                    agreements_disclaimers: agreements_disclaimers,
                    parent_guardian_consent: parent_guardian_consent,
                    is_open: this.data.block_status.find((o) => o.name === 'parent_guardian_consent').open
                });
            }, 10);
        },

        getData() {
            // console.log(this.backup_data)

            if (this.data.agreements_disclaimers && this.data.agreements_disclaimers.length !== 0) {
                this.tab_menus.push({ text: 'Agreement & Disclosure' });
            }

            if (this.data.parent_guardian_consent && this.data.parent_guardian_consent.length !== 0) {
                this.tab_menus.push({ text: 'Guardian Consent' });
            }

            this.handle_data = this.data.settings;
            this.handle_data[3].section_groups[3].group_setting.forEach((e,k)=>{
                if(e.label==='auto_rejection_social_follower_count_condition'){
                    this.followIndex= e.client_view.val ==='AND' ? 0 : e.client_view.val ==='OR' ? 1: null;
                }
            });

            let arr = this.handle_data[1].section_groups.filter(e => {return e.tip === 'application'});
            this.auto_email = arr.some(e=>{return e.is_switch});

            // What's happening here? Why is the data being processed twice???
            setTimeout(() => {
                // Waiting for data processing to complete
                this.backup_data = JSON.parse(JSON.stringify(this.data));
                this.is_inited = true;
            }, 1000);

            this.hanldeAutoRe(this.autoRejAllHide);
       
        },

        hanldeAutoRe(val){
            this.tab_menus.forEach(e=>{
                if(e.text=== 'Auto-Rejection'){
                    e.show=!val
                }
            });

            if(val){
                this.handle_data[3].section_groups[0].is_switch = false;
            } 
        },

        //++++++++++++++++++++++++++++++++++++++++++
        //makeing time
        //++++++++++++++++++++++++++++++++++++++++++
        handleDateTime(obj, field) {
            // console.log('obj',obj)
            if (obj.key === 'Start date') {
                this.handle_data[0].section_groups[1].group_setting[0].client_view[field] = obj.val;
            }
            if (obj.key === 'Deadline') {
                this.handle_data[0].section_groups[1].group_setting[1].client_view[field] = obj.val;
            }

            if (obj.key === 'Start date' || obj.key === 'Deadline') {
                let sta = this.handle_data[0].section_groups[1].group_setting[0].client_view;
                if (sta.date) {
                    this.handle_data[0].section_groups[1].group_setting[1].client_view.min_date = this.combineDateTime(sta.date, sta.time);
                }
                let dea = this.handle_data[0].section_groups[1].group_setting[1].client_view;
                if (dea.date) {
                    this.handle_data[0].section_groups[1].group_setting[0].client_view.max_date = this.combineDateTime(dea.date, dea.time);
                }

                this.handle_data[0].section_groups[1].group_setting[0].client_view.val = this.combineDateTime(sta.date, sta.time);
                this.handle_data[0].section_groups[1].group_setting[1].client_view.val = this.combineDateTime(dea.date, dea.time);
            }

            //----------------------------------------
            if (obj.key === 'Send DateTime') {
                let sta = this.handle_data[1].section_groups[obj.index].group_setting[ this.checkTimeIndex(this.handle_data[1].section_groups[obj.index]) ].client_view;
                this.handle_data[1].section_groups[obj.index].group_setting[ this.checkTimeIndex(this.handle_data[1].section_groups[obj.index]) ].client_view[field] = obj.val;
                this.handle_data[1].section_groups[obj.index].group_setting[ this.checkTimeIndex(this.handle_data[1].section_groups[obj.index]) ].client_view.val = this.combineDateTime(sta.date, sta.time);
                this.handle_data[1].section_groups[obj.index].group_setting[ this.checkTimeIndex(this.handle_data[1].section_groups[obj.index]) ].client_view.refrash_key +=1;
            }

            this.$emit('update-data', { data:this.handle_data });
        },

        calendarChange(obj) {
            this.handleDateTime(obj, 'date');
        },

        timeChange(obj) {
            this.handleDateTime(obj, 'time');
        },

        openForm(type) {
            switch (type) {
                case 'all':
                    this.$refs.nav.selectIndex(0);
                    break;

                case 'email_settings':
                    this.$refs.nav.selectIndex(1);
                    break;
            }
        },

        combineDateTime(dateString, timeString) {
            // 使用 moment 解析日期和時間
            let date = moment(dateString, this.handle_data[0].section_groups[1].group_setting[0].client_view.plac);
            let time;

            // 檢查 timeString 是否為完整的日期時間格式
            if (moment(timeString, 'YYYY-MM-DD HH:mm:ss', true).isValid()) {
                // 如果是完整的日期時間格式，直接解析
                time = moment(timeString, 'YYYY-MM-DD HH:mm:ss');
            } else if (/^\d{1,2}:\d{2} [APMapm]{2}$/.test(timeString)) {
                // 如果是12小時制時間格式
                time = moment(timeString, 'h:mm A');
            } else if (timeString.includes(' ')) {
                // 如果包含空格（可能是其他日期時間格式）
                time = moment(timeString, 'YYYY-MM-DD HH:mm:ss');
            } else {
                // 默認情況下，使用當前時間
                time = moment();
            }

            // 設置日期的時間部分
            if (date.isValid() && time.isValid()) {
                date.set({
                    hour: time.get('hour'),
                    minute: time.get('minute'),
                    second: 0
                });
            }

            // 格式化為 "YYYY-MM-DD HH:mm:ss"
            return dateString && date.isValid() ? date.format('YYYY-MM-DD HH:mm:ss') : moment(dateString).format('YYYY-MM-DD HH:mm:ss');
        },

        //+++++++++++++++++++++++++++++++++++++++++++++++++
        //+++++++++++++++++++++++++++++++++++++++++++++++++
        saveTanking(val) {
            // this.handle_data[1].section_groups[0].group_setting[0].client_view.is_edit = false;
            // this.handle_data[1].section_groups[0].group_setting[0].client_view.val = this.handle_data[1].section_groups[0].group_setting[0].client_view.temp_val;
         
            this.handle_data[1].section_groups[0]=val;
            this.$emit('update-data', { data:this.handle_data });
        },

        update(obj) {
            this.error_msg = '';
            if (obj.key === 'thank_you_message') {
                let key=obj.spec?Number(obj.spec):0;
                this.handle_data[1].section_groups[0].group_setting[key].client_view.temp_val = obj.val;
            }

            if(obj.spec==='age-check'){
                this.handle_data[3].section_groups[1].error_msg='';
                let key=obj.key==='auto_rejection_age_min'? 0:1;
                this.handle_data[3].section_groups[1].group_setting[key].client_view.val = obj.val;
                if(key===0){
                    this.handle_data[3].section_groups[1].group_setting[key].client_view.err='';
                }
                this.checkAge();
                
            }

            const handleCheckFollow=()=>{
                if(!this.checkFollow()&& this.followIndex===0){
                    this.checkFollowIndex();
                }
            }

            if(obj.spec==='tk-follow'){
                this.handle_data[3].section_groups[3].group_setting.forEach((e,k)=>{
                    if(e.label==='auto_rejection_social_follower_count_tiktok_min'){
                        e.client_view.val = obj.val;
                    }
                });
                handleCheckFollow();
            }

            if(obj.spec==='ig-follow'){
                this.handle_data[3].section_groups[3].group_setting.forEach((e,k)=>{
                    if(e.label==='auto_rejection_social_follower_count_instagram_min'){
                        e.client_view.val = obj.val;
                    }
                });
                handleCheckFollow();
            }
            this.$emit('update-data', { data:this.handle_data });
        },

        checkFollow(){
            const settings = this.handle_data[3].section_groups[3].group_setting;

            let hasTikTok = false;
            let hasInstagram = false;

            settings.forEach(e => {
                if (e.label === 'auto_rejection_social_follower_count_tiktok_min') {
                    hasTikTok = e.client_view.val;
                }
                if (e.label === 'auto_rejection_social_follower_count_instagram_min') {
                    hasInstagram = e.client_view.val;
                }
            });

            return hasTikTok && hasInstagram;
        },
        //---------------------------------
        //switch email
        handleAllEmailAuto(){

            const sw=(val)=>{
                this.handle_data[1].section_groups.forEach(item => {
                    if(item.tip==='application'){
                        item.is_switch=val;
                    }
                    if(item.group_name==='automated_email'){
                        item.is_switch=val;
                    }
                });
            }

            if(this.auto_email){
                sw(false);
                this.auto_email=false;
            }else{
                sw(true);
                this.auto_email=true;
            }
            this.$emit('update-data', { data:this.handle_data });
        },

        switchOneResonse(val){
            val.is_switch = !val.is_switch;
            let arr= this.handle_data[1].section_groups.filter(e=>{return e.tip ==='application'});
            let findSomeSwitch=arr.some(e=>{return e.is_switch});
            let findAllNotSwitch=arr.every(e=>{return !e.is_switch});

            if(findSomeSwitch){
                this.auto_email=true;
            }else if(findAllNotSwitch){
                this.auto_email=false;
            }

            this.$emit('update-data', { data:this.handle_data });
        },
        //---------------------------------

        //---------------------------------
        //switch auto reject
        handleSocAlert(val){
            if((val==='tk' && this.autoRejDis.tk_f) || (val==='ig' && this.autoRejDis.ig_f)){
                this.is_show_alert2_modal=true;
                this.alert.header= `Social Account field is required on your form.`;
                this.alert.text= `<p>To use this feature, follower data is required. Please add to the <span style="font-weight: 800">Social Account</span> section to your application and <span style="font-weight: 800">enable</span> authentication to continue.</p>`;
                this.alert.img= require('@/assets/images/social.png');
            }
        },

        switchOneAuto(index,is_disabled){
            if(is_disabled && index!==0){
                this.is_show_alert2_modal=true;

                if(index===1){
                    this.alert.header= `Enable the Age field to use this feature.`;
                    this.alert.text= `<p>To use this feature, applicant age data is required. Please enable the <span style="font-weight: 800">Age</span> field under <span style="font-weight: 800">‘Edit Application > Basic Info’</span> to continue.</p>`;
                    this.alert.img= require('@/assets/images/birthday.png');
                }else if(index===2){
                    this.alert.header= `Enable the Country/Location field to use this feature.`;
                    this.alert.text= `<p>To use this feature, applicant location data is required. Please enable the <span style="font-weight: 800">Country/Location</span> field under <span style="font-weight: 800">‘Edit Application > Basic’</span> Info to continue.</p>`;
                    this.alert.img= require('@/assets/images/location.png');
                }else{
                    this.alert.header= `Social Account field is required on your form.`;
                    this.alert.text= `<p>To use this feature, follower data is required. Please add to the <span style="font-weight: 800">Social Account</span> section to your application and <span style="font-weight: 800">enable</span> authentication to continue.</p>`;
                    this.alert.img= require('@/assets/images/social.png');
                }
            
            }else{
                
                
                if(index===0){
                    if(this.handle_data[3].section_groups[index].is_switch){
                        this.handle_data[3].section_groups.forEach((e,k)=>{
                            e.is_switch=false;
                        })
                    }else{
                        this.handle_data[3].section_groups.forEach((e,k)=>{

                            if(k===0){
                                e.is_switch=true;
                            }

                            if(!is_disabled.age && k===1){
                                e.is_switch=this.handle_data[3].section_groups[index].is_switch;
                            }
                            
                            if(!is_disabled.loc && k===2){
                                e.is_switch=this.handle_data[3].section_groups[index].is_switch;
                            }

                            if(!is_disabled.follow && k===3){
                                e.is_switch=this.handle_data[3].section_groups[index].is_switch;
                            }
                        })
                    }
                }else{
                    this.handle_data[3].section_groups[index].is_switch= !this.handle_data[3].section_groups[index].is_switch;
                }

                if(index!==0){
                    //handle all switch
                    let arr= this.handle_data[3].section_groups.filter((e,k)=>{return k!==0});
                    let findSomeSwitch=arr.some(e=>{return e.is_switch});
                    let findAllNotSwitch=arr.every(e=>{return !e.is_switch});
        
                    if(findSomeSwitch){
                        this.handle_data[3].section_groups[0].is_switch=true;
                    }else if(findAllNotSwitch){
                        this.handle_data[3].section_groups[0].is_switch=false;
                    }
                }

                let hanBox=this.handle_data[3].section_groups[index];
                if(index=== 1 && !hanBox.is_switch){
                    hanBox.error_msg='';
                    hanBox.group_setting.forEach(e=>{
                        if(e.client_view){
                            e.client_view.val='';
                        }
                    })
                }

                if(index===3 && !hanBox.is_switch){
                    hanBox.group_setting.forEach(e=>{
                        if(e.client_view){
                            e.client_view.val='';
                            if(e.client_view.error_msg){
                                e.client_view.error_msg='';
                            }
                        }
                    })
                }
                //目前為固定的位子
                let rej_location_open=index ===2 ? this.handle_data[3].section_groups[index].is_switch: null;
                this.$emit('update-data', { data:this.handle_data, rej_open: rej_location_open });
            }
        },

        updateLocation(obj){
            this.handle_data[3].section_groups[2].group_setting[0].client_view.input_option=obj;
            this.handle_data[3].section_groups[2].group_setting[0].client_view.val=obj.filter(e=>{return e.click});
            this.$emit('update-data', { data:this.handle_data });
        },

        remove(val){
            this.handle_data[3].section_groups[2].group_setting[0].client_view.input_option = this.handle_data[3].section_groups[2].group_setting[0].client_view.input_option.map(item => {
                if (item.id === val.id) {
                    return { ...item, click: false };
                }
                return item;
            });
            this.handle_data[3].section_groups[2].group_setting[0].client_view.val= this.handle_data[3].section_groups[2].group_setting[0].client_view.val.filter(item => item.id !== val.id);
            this.$emit('update-data', { data:this.handle_data });
        },

        updateDataInSide(data){
            this.$emit('update-data', { data:this.handle_data });
        },
        //++++++++++++++++++++++++++++++++++++++++++
        //saveing
        //++++++++++++++++++++++++++++++++++++++++++
        saveTitle(val) {
            if (val.type === 'edit') {
                let value = val.val;
                this.handle_data[0].section_groups[0].group_setting[0].input_value = value.application_title;
                this.handle_data[0].section_groups[0].group_setting[1].input_value = value.application_url;
                this.handle_data[0].section_groups[0].group_setting[2].input_value = value.create_tag;
                this.handle_data[0].section_groups[0].group_setting[3].input_value = value.meta_description;
                this.$emit('update-data', { data:this.handle_data, refrash_key:true });
                this.$store.state.is_loading = false;
            }
        },

        emailSave(val){
            this.handle_data=val;
            this.$emit('update-data', { data:this.handle_data });
        },

        //++++++++++++++++++++++++++++++++++++++++++
        //other
        //++++++++++++++++++++++++++++++++++++++++++
        checkScIndex:checkScIndex,
        checkTimeIndex:checkTimeIndex,

        checkAge(){

            let min =this.handle_data[3].section_groups[1].group_setting[0].client_view.val;
            let max =this.handle_data[3].section_groups[1].group_setting[1].client_view.val;
            const integerPattern = /^\d*$/;
            
            if( (min && !integerPattern.test(min)) || (max && !integerPattern.test(max))){
                this.handle_data[3].section_groups[1].error_msg='You can only enter integers.';
                return 
            }

            if(min && max){
                if(Number(max) < Number(min)){
                    this.handle_data[3].section_groups[1].error_msg='The maximum age cannot be less than the minimum age.';
                } 
            }
        },

        checkFollowIndex(){
            
            this.followIndex= this.followIndex === 0 ? 1 : 0;

            this.handle_data[3].section_groups[3].group_setting.forEach((e,k)=>{
                    if(e.label==='auto_rejection_social_follower_count_condition'){
                        e.client_view.val = this.followIndex === 0 ? 'AND' : 'OR';
                    }
                });
            this.$emit('update-data', { data:this.handle_data });
            },
        
        //+++++++++++++++++++++++++++++++++++++++
        //custom question handle 
        //+++++++++++++++++++++++++++++++++++++++

        handleClick(e) {
            if (this.$refs.el && !this.$refs.el.contains(e.target)) {
                this.open_list_val.val = false;
            }
        },
    },

    mounted() {
        this.getData();
    },

    created() {
        window.addEventListener('click', this.handleClick);
    },

    destroyed() {
        window.removeEventListener('click', this.handleClick);
    },

}
</script>

<style lang="scss">
@mixin flexCenter() {
    display: flex;
    align-items: center;
}

.prog-set-form-right-wrap {
    .pick-date-box .mx-datepicker {
        width: 100% !important;
    }

    .tab-head {
        color: var(--black-90);
        position: sticky;
        top: 0;
        background-color: white;
        padding: 24px;
        z-index: 99;
        display: flex;
        align-items: center;

        h2 {
            font: var(--font-med-24);
            margin: 0;
            flex: 1;
        }

        .ui-navi .link {
            height: 32px;
            white-space: nowrap;
            font: var(--font-med-12);
        }
    }

    .foot-box {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: flex-end;
        padding: 24px;

        .ui-button {
            margin-left: 16px;
        }
    }
   
    .svg-icon {
        width: 16px;
        height: 16px;
        cursor: pointer;
    }

    .red{
        color:var(--red);
    }

    .data-list-right {
        height: calc(100vh - 48px);
    }

    .big-title {
        font: var(--font-med-20);
        color: var(--white);
    }

    .set-box {
        background: var(--white);
        border-radius: 6px;
        margin-top: 16px;
        padding: 8px 12px;

        &:last-child {
            margin-bottom: 36px;
        }

        .title-top {
            @include flexCenter();
            justify-content: space-between;

            .title {
                font: var(--font-med-20);
            }

        }

        .url-link-one-line{
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            width: 100%;
            display: block;
        }

        .desc {
            font-size: 12px;
            color: var(--black-75);
            margin: 8px 0;
            flex:1;
            // word-break: break-all;
        }


        .content-box {
            padding: 0 0 16px;

            .small-title-box{
                @include flexCenter();

                p{
                    font: var(--font-med-16);
                    flex:1;
                }

                .small-title-box-right{
                    @include flexCenter();
                }

                .open-pre{
                    color:var(--blue);
                    font-size:12px;
                    cursor:pointer;
                    margin-right: 4px;
                }
            }

            .sub-mes-box{
                @include flexCenter();

                .s-tit{
                    font-size: 14px;
                    width: 48px;
                    mix-width: 48px;
                    margin-right: 10px;
                }
                .desc,.the-input{
                    flex:1;
                    margin-right: 10px;
                }
            }

            .small-text {
                @include flexCenter();
                font: var(--font-med-16);
                justify-content: space-between;

                .small-btn {
                    @include flexCenter();
                    height: unset;
                    color: var(--green);
                    border: solid 1px var(--border);

                    .svg-icon {
                        fill: var(--green);
                        margin-right: 4px;
                    }
                }

                &.small-text-disabeld{

                }
            }

            .small-text-dec {
                font-size: 14px;
            }

            .url {
                color: var(--blue);
                font-size: 12px;
            }

            .text-box {
                margin-top: 12px;
            }

            .ui-input{
                margin: 4px 0;
            }


            .date-box {
                margin-top: 8px;

                .title {
                    @include flexCenter();
                    justify-content: space-between;
                    font: var(--font-med-12);
                }

                .desc {
                    margin: 4px 0;
                }
            }

            .value-box{
                @include flexCenter();

                .left-text{
                    font:var(--font-med-12);
                    width: 32px;
                }

                .ui-input{
                    flex:1;
                    margin-left: 8px;
                }

                &.value-box-err{
                    .ui-input{
                        border:solid 1px var(--red);
                    }
                }   

            }

            .select-box{
                .item-box{
                    width: 100%;
                }

                .scrollbar-content{
                    height:240px;
                }

                .svg-icon{
                    width: 12px;
                    height: 12px;
                }

                .ui-button{
                    justify-content:flex-start;
                }
            }

            .err-msg {
                font-size: 12px;
                font-weight: 500;
                color: var(--alert);
                text-align: right;
            }

            ul {
                display: flex;
                justify-content: space-between;
                align-items: center;
                margin-top: 4px;

                .ul-box {
                    display: flex;
                    flex-wrap: wrap;
                    gap: 4px 8px;
                    align-items: center;

                    li {
                        display: inline-flex;
                        align-items: center;

                        i {
                            height: 14px;
                            width: 14px;
                            margin-left: 4px;
                            cursor: pointer;
                            border: none;

                            svg {
                                height: 100%;
                                width: 100%;
                                margin: 0;
                                fill: var(--red);
                            }
                        }
                        span {
                            font: var(--font-med-12);
                            display: flex;
                            align-items: center;
                        }

                    }
                }

            }
            
            .flex{
                @include flexCenter();
                flex:1;
                .ui-input{
                    width: 100%;
                }
            }

        }

        .application-handle{
            padding-left: 8px;
            border-left: solid 2px var(--neutral);

            .btn-sch-box{
                display: grid;
                grid-template-columns: 1fr 1fr;
                gap:4px;

                .btn{
                    @include flexCenter();
                    justify-content: center;
                    font:var(--font-med-12);
                    border:solid 1px var(--neutral);
                    height: 30px;
                    border-radius: 6px;
                    cursor: pointer;
                    transition: .3s;

                    .svg-icon{
                        width: 12px;
                        height: 12px;
                        margin-left: 4px;
                    }

                    &.pick-btn{
                        border:solid 1px var(--dark-blue);
                    }
                }
            }

            .edit-box{
                @include flexCenter();
                transition: .3s;
                border-radius: 6px;
                padding: 4px;
                cursor: pointer;
                margin-top: 4px;
                font: var(--font-med-12);
                width: fit-content;

                &.edit-box-red{
                    color:var(--red);
                }

                &:hover{
                    background-color: var(--light-neutral);
                }

                .svg-icon{
                    width: 12px;
                    height: 12px;
                    margin-right: 4px;
                }

                &.dis-edit-box{
                    pointer-events: none;
                    cursor: not-allowed;
                    opacity: .7;
                }
            }
        }

        .date-time-pick-box-err{
            .pick-date-box input{
                border:solid 1px var(--red);
            }
            
        }
    }

    .submit-btn {
        width: 100%;
    }

    .follow-check{
        align-items: flex-start;

        .svg-icon {
            min-width: 12px;
            margin-top: 2px;
        }
    }
}

.application-alert-modal2{
    .delete-header{
        font:var(--font-med-16);
        padding: 16px 24px;
        display: flex;
        gap:16px;
        align-items: center;

        h2{
            flex:1;
        }

        i{
            cursor: pointer;

            svg{
                fill: var(--black-50);
                width: 14px;
                height: 14px;
            }
        }
    }

    .content{
        padding: 24px;

        img{
            width: 100%;
            height: 360px;
            margin-bottom: 24px;
        }

        h3{
            font:var(--font-med-24);
            margin-bottom: 16px;
        }

        p{
            font-size: 16px;
            color: var(--black-90);
            margin-bottom: 24px;
        }

        .ui-button{
            width: 100%;
        }
    }


}
</style>